import { Building2 } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const employerReviewStatusOptions: ComboboxFilterOption<string>[] = [
  { label: 'Approved', value: 'approved' },
  { label: 'Pending', value: 'pending' },
  { label: 'Denied', value: 'denied' },
]

const EmployerReviewStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = employerReviewStatusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Employer Review Status', options: filteredOptions || [] }]}
        placeholder='Search employer review statuses...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={employerReviewStatusOptions || []}
          noSelectionText='Employer Review Status'
          pluralIdentifier='employer review statuses'
        >
          <Building2 size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EmployerReviewStatusFilter
